import { SalutationEnum } from '@pe/checkout/types';

export const SALUTATION_TRANSLATION = {
  [SalutationEnum.SALUTATION_MR]: $localize `:@@salutation.SALUTATION_MR:`,
  [SalutationEnum.SALUTATION_MRS]: $localize `:@@salutation.SALUTATION_MRS:`,
  [SalutationEnum.SALUTATION_OTHER]: $localize `:@@salutation.SALUTATION_OTHER:`,
};
